// Vue Soir : le nom et la remorque habituelle (les mêmes le Jour), puis les champs du Soir.
const EVENING_VIEW_FIELDS = ["truck_name", "compartment_name", "evening_is_active", "evening_driver_employee_id"];

export function truckColumnsForPeriod(columns, period) {
  if (period !== "evening") return columns.filter(column => column.dompeurOnly || !column.key.startsWith("evening_"));
  const byKey = new Map(columns.map(column => [column.key, column]));
  return EVENING_VIEW_FIELDS.map(key => byKey.get(key)).filter(Boolean);
}

export function truckIsActiveForView(truck, period) {
  return (period === "evening" ? truck?.evening_is_active : truck?.is_active) === true;
}
